// extracted by mini-css-extract-plugin
export default {"page":"app_page__XMnOB","content":"app_content__kUybc"};